<template>
  <v-container fluid grid-list-md>
    <users></users>
  </v-container>
</template>
<script>
import Users from '../components/Users/List.vue';

export default {
  components: {
    Users,
  },
};
</script>
